module.exports = __webpack_public_path__ + "img/img_body_biz_ibk_logo.6c6c1719.png";